module.exports = __webpack_public_path__ + "static/TextureBackground02-c656f0539acbb93b404f120aa04cb9ed.jpg";